export const LAST_PATCH_NOTES_ARSON = `
### Versión 6.21 (??/11/2026)
* Modo protección de datos:
  - Añadido modo especial para perfil ARSON que oculta los datos referentes a CUPS y datos extra.
* Menú de usuario:
  - Actualizados textos y controles para modos especiales del perfil ARSON.
  - Añadida barra de estado de los modos especiales para perfil ARSON bajo el nombre de usuario.
* Navegación:
  - Añadida nueva funcionalidad global de guía de ayuda.
* Alarmas -> Alarmas personalizadas:
  - Añadida guía de ayuda.
  
### Versión 6.20 (03/11/2026)
* Angular:
  - Actualizada librería de selector de fecha deprecada.
  - Actualizadas librerías de Angular para corregir nuevas vulnerabilidades.
  - Refactorizaciones de código para mejorar la seguridad y el mantenimiento.
  - XSS en el DOM de ventanas emergentes/descripciones de mapas, etiquetas de capas, contenido de SweetAlert y nombres proporcionados por el usuario: saneamiento y escape de HTML.
  - Inyección de URL/recursos en el renderizador de PDF, incluyendo solicitudes de estilo SSRF: restringe las URL de recursos y elimina elementos/estilos riesgosos.
  - Inyección de fórmulas/CSV: neutraliza las fórmulas de hojas de cálculo y cita las celdas de forma segura.
  - Ejecución dinámica de código insegura: reemplaza eval() en el decodificador de Contazara con una búsqueda.
  - Claves de autenticación generadas débiles o sesgadas: utiliza CSPRNG con muestreo por rechazo.
  - Refuerzo del contenedor: imágenes de Node/nginx fijas y entorno de ejecución de nginx sin privilegios de root en Dockerfile.
* Dispositivo -> Fabricantes MBus -> Clave privada:
  - Corregido servicio de guardado.
* Errores HTTP:
  - Añadidos mensajes de error faltantes.
* Dispositivo -> Detalle -> Log de tramas:
  - Si el dispositivo es TPE se omitirá la columna de tipo.
* Navegación:
  - Actualizado control de navegación al cambiar los selectores de cliente/entidad/agrupación para evitar errores de carga.
* Sensórica -> Mapa interactivo de fugas:
  - Actualizado color por encima de filtro para distinguirlo de las posibles alarmas.
  - Añadido dato de rango en popup de mapa.
* Análisis de datos -> Balances -> Nuevo:
  - Corregido un error por el que al crear un nuevo balance desde una selección previa de contadores, éstos no se añadían automáticamente al balance como hijos.
* Dispositivo -> Detalle:
  - Corregido un error en la gráfica de consumo por el que si se buscaban datos con un tipo de gráfica seleccionado, no se mostraban las alarmas.
  - Añadida pestaña de datos extra.
* Mantenimiento -> Global -> Tramas NBIoT:
  - Añadido botón de descarga de log en menú de componente.
* Mapas:
  - Añadida opción de selección de dispositivos a partir de todos los polígonos cargados.
* Alarmas -> Alarmas personalizadas:
  - Corregido texto y controles de alarma de fuga.
* Dispositivo -> Nuevo:
  - Actualizada estructura y estilos de formulario.
* Cliente/Entidad/Agrupación:
  - Actualizada estructura y estilos de formulario.
* Ficheros de salida:
  - Actualizada estructura y estilos de formularios.
* Usuarios -> Formulario:
  - Actualizada estructura y estilos de formulario.
* Datos customizados -> Listado de CUPS:
  - Corregido un error en la creación de nuevo CUPS que añadía campos incorrectos al formulario.
* Mantenimiento -> Configuración externa -> API externa:
  - Añadida pantalla para configuración de API externa.
* Dispositivo -> Gestión de SIMs:
  - Añadida nueva pantalla para gestión de SIMs.
* Gateways -> En stock:
  - Añadido selector de banda en el diálogo de nuevo gateway.
* Mantenimiento -> Configuración interna -> Fabricantes:
  - Añadidas columna de datos extra de modelo.
* Dispositivo -> Listados -> Pendientes:
  - Corregida activación cuando hay PTA activo en la entidad.
* Dispositivo -> Listados -> Sustituciones pendientes:
  - Corregida columna de último valor.

### Versión 6.19.1 (22/10/2026)
* Ficheros de salida -> Descarga de fichero:
  - Añadida opción de último valor a descarga de fichero IZFE.

### Versión 6.19 (21/10/2026)
* Dispositivo -> Nuevo:
  - Añadido CUPS a parámetros opcionales para todos los dispositivos (oculto hasta actualización de servicio).
* Dispositivo -> Detalle -> Log de comunicaciones:
  - Corregido parseo de trama.
* Sensórica -> Mapa interactivo de fugas:
  - Actualizada fecha de referencia de ruido a último día.
  - Actualizado dato de ruido de referencia a último dato recibido en vez del más alto registrado.
  - Los textos de ayuda ya no se ocultan al hace click en el icono.
* Alarmas:
  - Unificados textos de alarmas por tipo.
* Mantenimiento -> Configuración interna -> Fabricantes:
  - Añadidas columnas de bandas y modelo TPE a la tabla.
  - Añadida edición de bandas y modelo TPE en modal de nuevo/editar.
* Mantenimiento -> Configuración externa:
  - Actualizada configuración TPE.
* Válvulas:
  - (1076) Actualizado control de válvula para permitir apertura por porcentaje personalizado para las válvulas Aquaguard Y26/Y27 (ARSON).
  - Actualizada gestión de comandos de válvula para evitar errores y facilitar la lectura de código.
* Cobertura -> Test de cobertura:
  - Corregido un error por el que se ocultaban las localizaciones en el mapa al clicar en un marcador de test.
  
### Versión 6.18.1 (16/10/2026)
* Tablas:
  - Corregido un error por el que las tablas secundarias dentro de las tablas principales no se cargaban correctamente al inicializarse.
* Telecontrol -> Telemedida:
  - Corregido un error por el que se ignoraba la fecha seleccionada al descargar fichero horario.
* Dispositivo -> Listados -> En red:
  - Corregidos enlaces de acciones de ver selección.
* Mapas:
  - Corregido un error en la carga de librerías de mapas que provocaba fallos en la inicialización de los mapas con capas de calor.
  
### Versión 6.18 (13/10/2026)
* Análisis de datos -> Balances:
  - Añadida columna de agrupación al listado.
* Mapas:
  - Corrección de carga de encuadre guardado en datos de sesión.
  - Añadida opción de filtrado por metrología de dispositivos.
  - Unificados filtros en un mismo panel.
* Principal:
  - Ahora los dispositivos que se reciban vía TPE o LNS se considerarán pendientes si no tienen dato de última comunicación.
* Fabricantes:
  - Eliminadas traducciones independientes del Frontend, ahora los fabricantes/modelos se mostrarán con los nombres guardados en base de datos.
* Principal:
  - Corregido un error por el que los TXN se mostraban como concentradores en las gráficas y en el mapa.
* Dispositivo -> Detalle:
  - Añadido log de tramas para NBIoT UDP.
  - Añadida opción de recálculo de consumo en menú de componente.
* Concentrador -> Detalle:
  - Añadida opción de asignar/desasignar como fijo en tabla de contadores.
* CUPS -> Detalle:
  - Ahora siempre se mostrará la gráfica de consumo en el panel de información si existen datos aunque no haya ningún contador asociado al CUPS.
* Fabricantes/modelos:
  - Añadido modelo NBIoT Gas para Kaifa.
  - Añadido campo de dirección MBUS como campo obligatorio para modelos NBIoT UDP.
* Alarmas -> Alarmas personalizadas:
  - Actualizados parámetros para alarma de fugas.
  - Actualizados estilos y añadido editor por pasos de alarmas.
* Configuración externa:
  - Actualizados chequeos de Vodafone de modelo a tipo de comunicación NBIOT UDP.
  - Actualizados chequeos de configuraciones externas de entidad para evitar servicios redundantes.
* Chatbot:
  - Eliminada opción de entrenar desde el chat porque no funcionaba adecuadamente.
  - Añadida ayuda con información sobre la pantalla en la que el usuario esté ubicado.
  - Actualizada estructura de aplicación mostrada por el chatbot.
* Sensórica -> Mapa interactivo de fugas:
  - Recuperadas anclas de mapa y tabla en cabeceras para moverse entre secciones.
  - Corregido un error por el que los dispositivos destacados aparecían duplicados.
  - Corregido un error por el que en la tabla no se mostraba el último dato de ruido correctamente.

### Versión 6.17.1 (30/09/2026)
* Desbloqueo de edición de TAG Hermes y Log de tramas de NBIoT.
* Mapas:
  - Corrección de interacciones de mapas de sensórica con el mapa estándar en 2D y 3D.
  
### Versión 6.17 (28/09/2026)
* Mantenimiento -> Configuración externa:
  - Corregidos permisos para perfil USUARIO ARSON.
* Datos customizados -> Configuración de datos:
  - Corregido comportamiento de botón de habilitar CUPS.
* Principal:
  - Corregido un error por el que se duplicaban los chequeos de configuración externa.
* Login:
  - Corregida url de entrada para administradores de cliente con check de telecontrol.
* Agrupación -> Formulario:
  - Corregida visibilidad de opción de deshabilitar visualización en virtual.
* Tareas:
  - Corregido un error que provocaba que la tabla de progreso de la tarea no cargara todos los datos.
* Fabricantes:
  - Actualizados nombres de modelos del fabricante GWF.
* Dispositivo -> Detalle:
  - Corregido un error por el que se duplicaba el TAG para el modelo HERMES en la pestaña de datos.
  - (1328) Añadida opción de actualización de TAG para Hermes (oculto hasta actualización de backend).
  - (1338) Corregido log de tramas para concentradores.
* Gateway -> Detalle -> Listado de sniffer:
  - (1302) Ahora pueden asignarse contadores de otras entidades si el cliente tiene los gateways compartidos.
* Mantenimiento -> Global:
  - (1320) Añadido log de tramas global para NBIoT UDP (oculto hasta actualización de backend).  
* Mantenimiento -> Configuración interna -> Fabricantes:
  - Añadida opción de exportación a la tabla.
* Válvulas:
  - Añadidos textos de error 5501 a 5506.
* Sensórica -> Mapa interactivo de fugas:
  - Actualizados estilos y funcionalidades.
* (1281) Sensórica -> Mapa interactivo de presión:
  - Nueva pantalla de sensores de presión con mapas 2D y 3D interactivos.
  
### Versión 6.16.1 (15/09/2026)
* (1327) Principal:
  - Corregido un error por el que los sensores externos no se representaban correctamente en las gráficas y en el mapa.
* (1331) Dispositivo -> Detalle:
  - Corregidas gráficas de presión y temperatura para que el eje X sea lineal y no se comprima por falta de datos.
* (1330) Dispositivo -> Listados -> En red:
  - Corregido un error por el que no cargaba el modal de histórico de batería.
  - Corregida gráfica de batería para modelo AVK.
* (1329) Análisis de datos -> Gráfica de contadores:
  - Corregida carga con contadores preseleccionados.

### Versión 6.16 (14/09/2026)
* (1316) Mantenimiento -> Global -> Configuración externa:
  - Reubicado menú de configuración externa para facilitar el acceso.
  - Actualizado selector de entidad en creación de nueva configuración para permitir configuración a nivel cliente o entidad.
* Clientes -> Listado:
  - (1316) Añadida acción de configuración externa.
* Entidades -> Listado:
  - Ahora las acciones de configuración externa redirigen a la pantalla de configuración correspondiente.
* Fabricantes/modelos:
  - Ahora el modelo HERMES ya no requiere usuario y contraseña por defecto al importar.
* Entidad -> Formulario:
  - Corregido un error por el que no se actualizaba la visualización de datos al desactivarla.
* Telecontrol -> Equipos en test:
  - Añadida acción para cambiar el estado de la comunicación automática.
  - Corregido un error por el que se duplicaba el servicio de test.
* Dipositivo -> Nuevo:
  - Ahora puede seleccionarse utilizar los datos de API a nivel cliente, si existen, para dispositivos API sin necesidad de introducir datos adicionales.
* (1314) Tablas:
  - Ahora al ordenar datos, los valores nulos se considerarán siempre menores que los valores no nulos.
* Dispositivo -> Detalle:
  - (1300) Corregido un error por el que no se asignaba correctamente un CUPS creado desde el detalle de un dispositivo.
  - Añadido dato de GUID en pestaña de datos para dispositivos AVK VIDI Positioner NBIoT.
  - Corregido un error por el que no se podían crear nuevos datos extra en entidades sin CUPS.
  - (1318) Corregido eje Y en gráfica de temperatura para adaptarse correctamente a los valores mínimo y máximo de las series y añadida opción de compresión de eje.
  - Añadidos enlaces faltantes en tabla de sectores.
  - (1326) Añadida consulta de datos de dispositivo con sim Vodafone para visualizar respuesta en formato JSON, similar a AVK VIDI y TFS Amper Manómetro.
  - Añadida visualización de alarmas en la gráfica de datos de sensor.
* Dispositivo -> Listados -> Desactivados:
 - Eliminada opción redundante de mostrar detalle en tabla y corregido enrutamiento a dispositivo cuando se requiere actualizar la agrupación.
* Mapas:
  - (1294) Corregidos tooltips para mostrar datos acorde a metrología de dispositivo.
* Análisis de datos -> Gráfica de contadores:
  - Corregido un error por el que se mostraban dispositivos de metrología incorrecta en la gráfica.
* Dispositivo -> Listados -> En red:
  - (1311) Añadidas columnas para datos de presión y actualizados textos para columnas de sensores.
  
### Versión 6.15 (03/09/2026)
* Usuarios -> Formulario:
  - Corregido un error por el que no se actualizaban correctamente los permisos de entidad al cambiar de perfil.
  - (1285) Añadida selección de ámbito para perfiles correspondientes.
  - (1301) Ahora al crear una abonado desde un CUPS se seleccionarán automáticamente el perfil, la entidad y el CUPS correspondientes sin opción de cambio y se permitirá seleccionar el ámbito.
* Dispositivo -> Detalle:
  - Corregida sincronización de inputs y mapa en cambio de localización.
* Datos extra:
  - Unificados controles de cups y datos extra de todos los componentes al cambiar de entidad para evitar errores de sincronización.
* Concentrador -> Detalle:
  - Corregido un error en la carga de concentrador para perfiles no arson.
* Mapas:
  - Corregido un error por el que el modal de opciones tras seleccionar elementos en el mapa quedaba oculto en modo pantalla completa.
  - (1294) Corregida visualización de último valor en tooltips.
* (1289) Balances:
  - En la creacion/edición de balances, se añaden las válvulas disponibles. 
  - En la gráfica, se añaden los valores de las válvulas seleccionadas.
  - Corregido un error por el que no se cargaba correctamente el desplazamiento de series guardado en la gráfica de balance.
* (1293) Apator Ultrimis:
  - Corregido parseador de tramas.
* Alarmas:
  - Añadidas alarmas para cuando se recibe una trama LNS para un contador desactivado (ARSON).
* Análisis de datos -> Balances:
  - Corregido timeout en la carga del mapa del listado de balances.
* Nuevos dispositivos:
  - (1286) Creado modelo Constrat NBIoT Test device para poder cargarle valores desde la api de w-b.
  - (1288) NBIoT manómetro (TFS Amper): Configuración externa, webhooks, consulta de datos y detalle.
  - (1091) AVK VIDI sensor de estado de válvula: Configuración externa, consulta de datos y detalle.
* Dispositivo -> Detalle:
  - Corregido un error en la tabla de CUPS que impedía crear nuevos datos extra en entidades sin CUPS.
* (885) Alarmas -> Alarmas personalizadas:
  - Actualizados servicios y configuración de alarmas personalizadas.
  
### Versión 6.14 (28/07/2026)
* Dispositivo -> Detalle:
  - Corregido panel de datos Lora para tipo TPE.
  - Corregido un error por el que se corrompían los datos extra al crear la tabla de CUPS.
  - (1258) Adaptación de pestaña de red para Sagemcom NBIoT agua PUSH.
* Gateway -> Detalle:
  - Corregido un error por el que la tabla de contadores no cargaba si el servicio tardaba en responder.
* Mapas:
  - Añadida opción de carga de archivos KMZ.
  - Corrección de datos de contador en tooltips de mapa.
  - Corregido icono de concentradores TXN no asignados.
* Gráfica de consumo:
  - Corregido un error por el que se calculaban interpolados más allá del último valor de lecturas cuando existían alarmas posteriores.
* Gateway -> Detalle:
  - Añadido dato de AMEI faltante.
* (1258) Fabricantes/Modelos:
  - Añadido Sagemcom NBIoT agua PUSH.

### Versión 6.13 (22/07/2026)
* (1266) Dispositivos -> Listados -> WalkBy:
  - Añadidas opciones de tabla del listado de asignados.
* (1275) Dispositivos -> Listado interno:
  - Corregida edición de SF/ADR/Potencia.
* Navegación:
  - Habilitado cambio de perfil dinámico para usuarios ARSON.
  - Eliminada redirección a estado de comunicaciones como pantalla principal.
* Ficheros de salida -> Descarga de fichero:
  - Actualizada visualización de controles.
* Usuario -> Formulario:
  - Añadido aviso de cups no encontrado o asignado al buscar si no hay resultados.
* Mapas:
  - Corregido un error que impedía la carga de algunos archivos shapefile.
* (1249) Concentrador -> Detalle:
  - Se cambia la denominación de "fijos" a "prioritarios" para los contadores de la gota.
  - Se permite seleccionar varios contadores desde el mapa para asignarlos como prioritarios seleccionándolos con el polígono.
* (1255) Dispositivo -> Detalle:
  - Añadida opción en el menú para editar las claves de encriptación y autorización del contador, pidiendo confirmación por captcha si el contador ya tiene lecturas registradas.
  - Corregido: Algunos dispositivos no requieren clave de auth key.
  - Solucionado un error por el que los contadores en modo B no aparecían en la tarjeta.
* (1259) Alarmas -> Listado de alarmas / Electo SJ:
  - Cuando aparece la alarma de un Electo SJ que está enviando tramas semanales, se permite lanzar desde el propio listado el comando de cambio a tramas horarias; ahora también disponible para Electo Sonic y Conthidra Eregister.
  - El comando se envía a través de la cola de procesos, permitiendo lanzarlo sobre varios dispositivos a la vez.
* (1262) Mantenimiento -> Configurar -> Fabricantes / Dispositivo -> Detalle:
  - Añadida opción para Arson para editar la configuración especial de alarma de fuga (JSON) de los fabricante/tipo que la tengan disponible.
  - Añadida opción en el detalle del dispositivo para sobreescribir a nivel de contador individual la configuración de alarma de fuga del modelo.
* (1269) Dispositivos -> Listados -> Agrupaciones / WalkBy:
  - Añadida columna de walkby al listado de agrupaciones.
  - Añadidas traducciones para los nuevos eventos de usuario de walkby.
  - Eliminada la opción de pasar a "en red" un contador en walkby mientras forma parte de una agrupación walkby.
  - Eliminada la opción de desactivar el walkby para los dispositivos activos en agrupaciones walkby.
* Login -> Cambio de contraseña:
  - Corregido un error por el que, si se recargaba la página al cambiar la contraseña de forma obligatoria, se perdía la información del usuario.
* Fabricantes/Modelos:
  - Diehl: Añadidos los modelos "IZAR RC IoT LRW wMB v1.3" (contador+módulo) y "v1.3 RF" (módulo), y completada el alta del módulo RF v1.2 que faltaba. El visor de tramas del contador soporta la nueva trama DS40_I autocontenida (Frame Type 11, índice base + 15 deltas horarios).
  - Diehl Izar RC: Corregido el parseo de la seguridad de tipo 7, que no se estaba interpretando; ahora se resuelve mediante la clave mbus.
  - Kaifa MA408 (agua): Añadido el parseo de tramas del contador.
  - (1272/1273) Willfar Aflow LXC: Renombrado a "Willfar Aflow LXC AS923"; añadidos los dispositivos "Willfar Aflow LXC EU868" y "Willfar Aflow LXC V2 EU868" junto a sus parseadores y las acciones sobre la válvula; actualizado el parseo del V2 EU868 para soportar los datos completos de la válvula.
  - (1278) ADD Enprotech WM: Actualizado el protocolo de parseo de tramas.
* Sensórica -> Mapa interactivo de fugas:
  - Añadidos dispositivos con alarmas de fuga al mapa y la posibilidad de filtrar por los mismos, incluyendo la nueva alarma de posible fuga acústica de Kamstrup NBIoT junto a la ya existente de Sewering.
* Sensórica -> Sensores de distancia:
  - Corregido un error por el que la página principal de los sensores de distancia sin lecturas recientes no cargaba.
* Principal:
  - Corregidos los filtros aplicados al navegar desde la gráfica de totales del dashboard a los listados de dispositivos.
* Alarmas:
  - ADD Enprotech WM: Añadida una alarma para cuando se descarten datos por error en la trama.
  - Corregidas descripciones y traducciones de alarmas faltantes.

### Versión 6.12 (07/07/2026)
* (1247) Gateway -> Log de usuario:
  - Añadido al log de usuario del gateway el refresco de puntos finales.
* (1253) Fabricantes/Modelos:
  - Añadido dispositivo Apator Ultrimis.
* (1195) Dispositivo -> Listados:
  - Unificados filtros por metrología y comunicación para todos los listados que los incluyen.
  - Añadidos tipos de metrología y comunicación faltantes a los filtros.
* (1231) Dispositivo -> Detalle -> Logs:
  - Actualizado log de tramas para dispositivos externos.
* Navegación:
  - Adaptado buscador de entidad/agrupación a responsive.
* Chatbot:
  - Añadidas consultas del tipo "listado de válvulas cerradas".
  - Añadidas consulas del tipo "contadores diehl existentes".
  - Corregida carga de traducciones para el chatbot.
* Alarmas -> Alarmas de agrupación:
  - Actualizados emails de referencia para el envío de los mails de alarmas.
* Mapas:
  - Ahora se comprobará automáticamente si las coordenadas de los archivos shp importados están proyectadas o no.
* Gateway -> Detalle:
  - Actualizada pantalla en línea con el resto de dispositivos.
* Dispositivo/Cups - > Detalle:
  - Corrección de adaptación de fechas a timezone de agrupación en gráficas.
* Dispositivo -> Detalle:
  - Ahora si la agrupación en curso es virtual, aparecerá la agrupación del dispositivo en sus datos destacados.
  
### Versión 6.11 (24/06/2026)
* (1252) Fabricantes/Modelos:
  - Añadido dispositivo Sontex SuperAqua 1.
* (1238) Entidad -> Editar:
- Se añade un check para marcar si los cálculos de monitorización deben hacerse también en base a las agrupaciones por separado.
* (1238) Fiscalizador:
- Se hacen los ajustes necesarios para poder mostrar datos del fiscalizador a nivel de agrupaciones para las entidades que tengan marcado el check para realizar la monitorización por entidad.
* Dispositivo -> Detalle:
  - Ahora el patrón de consumo sólo se visualizará en la gráfica de consumo con tipo de gráfico "Consumo" o "Consumo normalizado".
  - Corregido un error por el que los datos de cups se perdían al navegar de una pestaña a otra en el detalle del dispositivo.
* (1225) Mantenimiento -> Global -> Contadores por fabricante/modelo:
  - Añadida pantalla de contadores por fabricante/modelo en clientes/entidades/agrupaciones.
* Alarmas -> Agrupación -> Alarmas de agrupación:
  - Corregido un error en la carga de traducciones para la generación de mails que interfería con las traducciones globales de la aplicación.

### Versión 6.10 (22/06/2026)
* (1171) Datos customizados -> CUPS -> Listado:
  - Añadida opción para asignar/desasignar un abonado a un CUPS desde la tabla de CUPS.
* (1171) CUPS -> Detalle:
  - Añadida opción en el detalle del CUPS para que se pueda asignar a un abonado existente.
  - Añadida opción en el detalle del CUPS para que se pueda desasignar un abonado del CUPS.
* (1171) Usuarios -> Formulario -> Nuevo:
  - Al crear un abonado, en vez de cargar directamente todos los CUPS ahora se espera a que el usuario busque alguna subcadena del mismo y muestre sugerencias.
* Fabricantes/Modelos:
  - (1243) Añadido modelo Comcore Gas.
  - (1146) Añadidos modelos Kaifa MA408 y Kaifa MA408K.
  - (1234) Añadido modelo Willfar AFLOW LXC.
* Login:
  - Corregido control de acceso para perfiles faltantes.
* Usuarios -> Formulario:
  - Corregidos varios errores en los selectores de permisos acorde al perfil del usuario actual y a la selección realizada.
  - Corregidos mensajes de error 1013 y 1029.
* Tareas:
  - Corregido un error al parar y reanudar las tareas que duplicaba la siguiente acción.
* Selectores de fecha:
  - Corregido un error por el que los selectores no actualizaban la fecha actual si se mantenía la aplicación abierta de un día previo.
* Ficheros de salida -> Descarga de fichero:
  - Añadida entidad Astigarraga a la descarga de archivo IZFE.
  - Añadida descarga de fichero Conasa para entidad Moncayo.
* Dispositivo -> Listados -> Listado interno:
  - Corregido un error que hacía que los tooltips se cerrasen automáticamente.
* Tablas:
  - Optimización de parseo de fechas y ordenamiento de tabla.
* Idiomas:
  - Ahora el front solo almacenará las traducciones para el login y el resto de los datos se cargarán desde servidor tras loguearse en la plataforma.
* Estado de red -> Global:
  - Corregidos enlaces en nueva pestaña.
* Principal -> Gestión de cliente:
  - Corregidos enlaces en nueva pestaña.
* (1136) Dispositivo/concentrador/cups -> Detalle:
  - Rediseño completo de la pantalla de detalle para mejorar la experiencia de usuario y facilitar el acceso a la información más relevante.
* Mapas:
  - Eliminado símbolo M de contadores MBus.
  - Activado mapa 3d a todos los perfiles.
  - Añadidas capas de calor en mapa 3d.
* Mantenimiento -> Monitorización -> Ver datos de entidades:
  - Corregidos cálculo de totales y porcentaje de leídos.
* (1250) Dispositivo -> Detalle:
  - Corregida creación de nuevo CUPS desde el detalle del dispositivo.
* Mantenimiento -> Construcción de red:
  - Añadida opción de eliminar conectores.
  - Ahora los tooltips son desplazables al igual que los elementos.

### Versión 6.09 (04/06/2026)
* (1228) Válvulas:
  - Se cambia la forma en la que procesamos el estado de las válvulas, ahora es el front quien genera los estados deseados teniendo en cuenta últimos comandos y estados.
* (1242) Fabricantes/Modelos:
  - Añadido modelo "GWF Sonico Nano 3".
* (1239) Mantenimiento -> Monitorización -> Ver datos de entidades:
  - Solucionado un error por el que en el fiscalizador no se sumaban las válvulas al total de dispositivos.
  - Solucionado un error en el que los porcentajes se sumaban en vez de hacer una media.
* Gateway -> Listado de sniffer:
  - Corregido un error por el que se lanzaba la tarea de asignación sin contadores válidos.
* Usuarios -> Formulario:
  - Corregida carga de idioma seleccionado en edición.
  - Corregido selector de permisos para usuarios con check de telemedida.
  - Corregido número de teléfono secundario.
  - Corregida carga en autoedición.
* Mantenimiento -> Usuarios (Cliente):
  - Corregido selector al editar permisos a nivel agrupación.
* Navegación:
  - Ahora el error de usuario no autorizado (1000) no redirigirá automáticamente a la página de no autorizado.
  - Corregido un error por el que no funcionaban los enlaces del buscador global por dispositivos cuando se encontraban varias coincidencias.
* (1241) Dispositivos -> Listados -> Dispositivos desconocidos:
  - Añadida columna de existencia en base de datos.

### Version 6.08 (02/06/2026)
* Idiomas:
  - Ahora los archivos de idiomas se integrarán directamente en el bundle de javascript para que los ficheros no sean directamente accesibles mediante url.
* Usuarios -> Formulario:
  - Corregida visualización de token permanente.
* Dispositivo -> Nuevo/Importar:
  - Ahora el campo SIM no es requerido.
* (1225) Mantenimiento -> Global -> Búsqueda global:
  - Añadidas opciones de búsqueda por id de archivo de importación y fabricante/modelo.
  - Añadida opción de búsqueda estricta.
* (1236) Dispositivo -> Listados -> Dispositivos desconocidos:
  - Añadida opción de corregir dirección Mbus.
* Dispositivo -> Listado -> Sustituciones:
  - Actualizada descarga de fichero de Moncayo con nombre Conasa.
* Principal:
  - Corregido un error por el que no se contabilizaban las válvulas en el cálculo de dispositivos pendientes totales.
* Telecontrol -> Equipos en test:
  - Corregida columna de modelo.
* Tablas:
  - Corregida visualización de paginación al pasar a doble línea por falta de espacio.
* Mapas:
  - Reubicado aviso de selección por KML en panel de archivos.
* Mantenimiento -> Global -> Usuarios:
  - Corregido un error por el que no funcionaban los desplegables de acceso al cambiar de página de tabla.
* Navegación:
  - Añadida búsqueda global interna de cups en el buscador de la barra de navegación superior similar a la de dispositivos.
* Alarmas -> Alarmas de agrupación:
  - Corregida generación de mails con nuevo formato de idiomas.
  - Añadida agrupación a asunto y nombre de archivo de mail generado.
  - Añadida opción de introducir a mano nuevos destinatarios.

### Version 6.07.1 (28/05/2026)
* Mapas:
  - Corregido error por el que los dispositivos fijados no podian ser seleccionados para ver en tablas y filtrar.
### Version 6.07 (26/05/2026)
* (1205) Dispositivo -> Nuevo:
  - Añadido dispositivo Contazara CZUS.
* Dispositivo -> Detalle:
  - (1226) Recarga de tarjeta al enviar estado de válvula.
  - (1226) Condiciones para mostrar el último comando y estado físico o no.
  - (1224) Se permite modificar un alias desde el detalle del dispositivo.
* (1224) Dispositivos -> Listado -> En red:
  - Se añade la columna alias en la tabla.
* (1224) Alarmas -> Agrupación:
  - Se añade la columna alias en la tabla de alarmas.
* Mapas:
  - (1229) Optimización de la lógica de filtrado por modelo.
  - (1229) Añadida la opción de filtrar un único modelo en el mapa.
  - (1229) Corrección de marcadores externos.
  - (1229) Corrección de selección mediante polígono kml.
  - (1221) Se añade el estado de válvulas a los tooltips de los mapas.
* (1197) Telecontrol:
  - Añadidas acciones de "Más información" y "Lista de errores" en equipos en test.
  - Corregida creación de usuarios de telemedida.
* (1197) EK280 -> Configuración:
  - Añadidas opciones de "Manetener información" (solo ARSON) y "Ventanas para test" en modal si el dispositivo está desactivado.
  - Corregida visualización de ventanas para perfiles no ARSON.
  - Corregida carga de selector de tarjetas SIM para evitar duplicados.

### Version 6.06 (20/05/2026)
* (1210) Gateways -> Datalogger:
  - Añadidos nuevos eventos de lorawan en el datalogger del gateway.
* (1212) Usuarios -> Nuevo/editar:
  - Corregido error por el que fallaba la creación de usuarios para perfiles con permisos de entidad.
* (1178) Entidad -> Nueva/Editar:
  - Añadida opción para elegir la comunidad autónoma correspondiente a Enagas para la entidad en clientes de gas.
* (1193) Dispositivos -> Listado -> Listado interno:
  - Añadida columna de último data up.
* (1193) Dispositivo -> Detalle:
  - Cambiada la tarjeta de última comunicación por la tarjeta de último data up en contadores y concentradores.
* (1200) Fabricantes:
  - Añadido modelo PLUM MacBAT.
* (1199) Actualización EK280/OWASYS:
  - Columna de número se serie adicional condicionada solo a OWASYS en telemedida.
  - Edición de número de serie adicional sólo para OWASYS.
  - Eliminado dato de número de serie de conversor EK280 en importación/nuevo.
* (1163) Dispositivo -> Sustituciones:
  - Añadida descarga de fichero para cliente Moncayo.
* (1189) Telecontrol -> Telemedida:
  - Corregido un error en la redirección al utilizar el link de los contadores si se requería un cambio de agrupación.
* (1220) Mantenimiento -> Construcción de red:
  - Añadido elemento customizable con inserción de imagen.
* (1220) Telecontrol -> Esquema de red:
  - Corregido menú de piezas.

### Version 6.05 (18/05/2026)
* (1196) Mantenimiento -> Global -> TPE -> Nuevo:
  - Se añade un boton para generar automaticamente una auth-key aleatoria.
* (1196) Dispositivos -> Listado -> En red:
  - Se añaden los filtros para LNS y TPE.
* (1196) Dispositivos -> Listado -> Pendientes:
  - Se añaden los filtros para LNS y TPE.
* (1208) Navegación:
  - Corregido un error por el que la duplicación de pestañas no actualizaba correctamente el client/entidad/agrupación y fallaba la carga de la url.
* (1207) Datos customizados -> Configuración de datos:
  - Corregido un error por el que no se cargaban correctamente la tabla de datos extra.
* (1207) Datos customizados -> CUPS -> Importar:
  - Corregida visibilidad de columnas de latitud y longitud.
* (986) Mapas:
  - Se añade opción para guardar las opciones de tamaño de icono, control de agrupaciones y control de clústeres del mapa.
  - Reorganizacion de iconos en el mapa para mantener un mejor orden.
  - Leyenda reorganizada para mantener un orden limpio.
  - Desde la leyenda, se permite modificar los colores de los estados de los dispositivos, y guardar esas opciones.
  - En el istado de capas disponibles, se añaden cabeceras a las capas para mantener un orden, y se añade un botón que permite mostrar el grupo o capa seleccionada en el mapa.
  - Se corrigen algunos errores a la hora de mostrar tooltips y en el ordenamiento por colores del mapa.

### Version 6.04 (11/05/2026)
* Usuario -> Formulario:
  - Corregida selección de entidades para perfiles de nivel entidad.
* (1092) Mantenimiento -> Global -> Configuración TPE:
  - Añadida pantalla con el resumen de las configuraciones TPE disponibles para el cliente.
* (1092) Mapas:
  - Añadida distinción para dispositivos TPE en el mapa.
* (1092) Entidad -> Listado:
  - Se añade una opción en la tabla para poder ver y cambiar la configuración TPE para la entidad.
* (1029) Alarmas:
  - Añadidas alarmas de errores de trama para Sagemcom NBIOT.
* (1124) Navegación:
  - Corregida carga de el selector de CUPS del navegador para forzar su recarga al añadir un nuevo CUPS.

### Version 6.03 (06/05/2026)
* (1177) Sustituciones:
  - Corregida visualización de CUPS sobre el que se realizó la sustitución.
* (1181) Dispositivo -> Datalogger:
  - Añadida alarma cuando llega un índice negativo.
* (1186) Navegación:
  - Corregida carga de flags de cliente/entidad al recargar pestaña.
* Datos customizados -> Configuración:
  - (1185) Ahora los datos extra aparecerán ordenados en la tabla por posición de columna en base de datos.
  - (1185) Ahora las discrepancias aprecerán ordenadas alfabéticamente por entidad en la configruación de plantilla de cliente.
  - (1183) Corregido servicio de obtención de definiciones.

### Version 6.02 (05/05/2026)
* (1182) Ficheros de salida -> Descarga de fichero:
  - Abierta opcion de descarga de fichero tipo "BASE" para todos los clientes y entidades.
* Dispositivos -> Nuevo:
  - (1174) Las columnas de MBUS se vuelven opcionales para los dispositivos lw-mbus.
  - (1102) Se elimina la columna NetworkKey de la precarga de datos.
* (1107) Agrupaciones -> Nuevo:
  - Se añade un selector con el tipo de agrupacion.
  - Se distinguen los tipos de agrupaciones virtual y virtual parcial.
  - Se permite a los admins de cliente y de entidad crear agrupaciones virtuales.
  - Se restringe la creación de agrupaciones virtuales completas a una sola por entidad.
* Navegación:
  - (1170) Corregido un error en la búsqueda global que evitaba la recarga en algunas ocasiones al cambiar de entidad/agrupación.
  - (1173) Corregido un error que impedía la actualización de la navegación al buscar un dispositivo que no tuviese una agrupación asociada.
* (1175) Selector de fechas:
  - Refactorizado para evitar el uso de doble input que daba lugar a errores.
* (1042) Usuarios -> Formulario:
  - Actualizado selector de cliente/entidad/agrupación por perfil en formulario.
* (1095) Mapas:
  - Corregida visualización de algunos datos de contadores LNS que no se mostraban en el tooltip del mapa para esos dispositivos.
* (1167) Tareas:
  - Corregida respuesta de tarea de activación para que asigne a cada dispositivo el código de respuesta individual.
  - Añadido control de error de servicio HTTP.
  - Añadido control para evitar que al detener una tarea mientras un elemento está en curso se cree otro hilo de ejecución al llegar la respuesta.
* (1172) Dispositivo -> Detalle:
  - Ahora se filtrarán los gateways en caso de que el cliente los tenga compartidos en un radio de 15km del dispositivo para evitar sobrecargar el mapa.
* (1002) CUPS a nivel de cliente:
  - Añadida plantilla de configuración de CUPS a nivel de cliente.

### Version 6.00 (27/04/2026)
* Fabricantes/Modelos:
  - (1144) Añadidos fabricantes y modelos de dispositivos ADD ADR.
* Dispositivos -> Log de tramas:
  - (909) Añadido parseador de tramas para Conthidra SmartIO.
  - (1144) Añadido parseador de tramas para dispositivos ADD ADR.
* (1164) Balances:
  - Resposicionado mapa bajo tabla.
  - Corregidos colores de balances en mapa.
  - Corregida redirección a nueva pestaña para perfiles no ARSON.
* (1157) Navegación:
  - Corregida carga de navegación cuando el cliente/entidad/agrupación es nulo.
  - Corregida actualización de navegación cuando se crea o borra un cliente/entidad/agrupación.
* Dispositivo -> Detalle:
  - (1158) Corregida edición de CUPS para perfiles no ARSON.
  - (1140) Añadido gráfico de batería a los concentradores.
  - (1140) Añadida información de consumo base a las tarjetas de consumo para los concentradores.
* (1159) Chatbot:
  - Corregidos accesos desde estructura a pantallas bloqueadas por cliente.
  - Corregido modo entrenamiento.
  - Añadido control de tamaño de fuente, borrado de chat y reposicionamiento.
* (1155) Selector de fechas:
  - Corrección de discrepancia entre la fecha seleccionada en el desplegable y la mostrada en la caja de texto.
* (1037) Datos customizados -> Configuración de datos:
  - Corregido un error por el que no se actualizaba la configuración de la entidad en curso tras aplicar cambios.
* (1068) Telemedida:
  - Deshabilitada la opción de fichero horario si no existen datos.
* (1166) Mantenimiento -> Global:
  - Corregido acceso para perfiles no ARSON.
* (1134) Mantenimiento -> Entidad -> Optimización de red:
  - Eliminado timeout de servicio de simulación.
  - Actualizado selector de entidades.
  - Ahora en la tabla de entidades podrá verse si la entidad tiene activada la optimización.
* (1168) Abonado:
  - Corregida carga de pantalla de cups.
* (1169) Listado de sustituciones:
  - Corregida edición de sustituciones.

### Version 5.99 (22/04/2026)
* (1078) Destalle de dispositivo -> Estado de válvulas:
  - Añadida informacion de acciones de usuario sobre las válvulas a la tabla de registro de estado de válvulas.
* (1127) Detalle de dispositivo:
  - Añadida tarjeta para mostrar el CSQ para los dispositivos PLUM con su historización.
* (1145) Login:
  - Corregido error por el que cuando la sesión caducaba no se permitía renovarla para cuentas con doble factor.
* (1143) Dispositivo -> Precarga de datos:
  - Corregida carga inicial de selector de fabricante.
  - Eliminada opción Cyble5IoT de preselección, ya incluida en la opción de LoRaWAN.
* (1149) Navegación:
  - Corregido un error en la carga inicial de entidad para perfiles no ARSON.
  - Corregido un error que provocaba la redirección a principal al visualizar un gateway de una entidad diferente a la actual en Mantenimiento > Global.
  - Corregido un error por el que se cancelaba la visualización de la tabla de tarea cuando existía una cambio de agrupación.
* (1150) Análisis de datos -> Balances:
  - Corregida redirección en nueva pestaña.
  - Corregido un error por el que no se cargaban los datos correctos en la nueva pestaña.
  - Corregida búsqueda de contadores faltantes.
* (1118) Chatbot:
  - Añadida base para chatbot.
* (1153) Mapa 3d:
  - Ahora el mapa cargará inicialmente con los clústeres desactivados.
  - Aumentado el tamaño de los marcadores estrella.
  - Corregido posicionamiento de popups y link a imágenes del dispositivo.
* (1154) Módulo tabla:
  - Corregido un error por el que los filtros por columna no se actualizaban con las preferencias de usuario.

### Version 5.98.1 (16/04/2026)
* Navegación:
  - (1141) Corregido un error que hacía que el buscador de contadores/cups no redirigiese correctamente si existía un cambio de agrupación.
  - (1142) Corregido un error que impedía la carga de los desplegables de entidad al iniciar la aplicación para perfiles no ARSON.

### Version 5.98 (15/04/2026)
* Dispositivo -> Nuevo:
  - (909) Añadido nuevo dispositivo Diehl Izar RC.
  - (1129) Al precargar un contador, los perfiles Arson podrán seleccionar que son contadores de tipo LNS en caso de que la entidad tenga configuración LNS.
* Angular:
  - (1096) Versión de angular actualizada a Angular 21.
  - (1096) Implementadas signals en componentes de Angular para mejorar la comunicación entre componentes.
  - (1132) Corregidos errores de sincronización al abrir pantallas de detalles en nuevas pestañas.
  - (1117) Corregido un error por el que no se recargaban los listados después de una acción debido a la actualización de Angular.
* (1103) Datos customizados -> Importación de PTA:
  - Reubicada importación de correcciones PTA en menú de CUPS.
  - Reubicada importación de PTA en tabla de PTA.
* (1106) Navegación:
  - Corregida visualización de listado de entidad en desplegable para perfiles no ARSON.
  - Corregido filtrado de desplegables.
* Detalle de gateway -> Configurar:
  - (1099) Corregido feedback cuando no hay respuesta al leer APP EUIs configurados.
  - (1108) Añadido feedback de borrado de puntos finales al refrescar gateway.
* (1116) Detalle de dispositivo -> Anotaciones:
  - Corregida carga de fecha inicial.
* Detalle de dispositivo:
  - (1115) Ahora si el dispositivo se recibe vía LNS de Netmore, aparecerá indicado junto al estado.
  - (1094) Se permite a los admin. de cliente cambiar la clase del dispositivo.
  - (1123) Se permite editar la zona horaria de un dispositivo.
* (1114) Estilos globales:
  - Habilitado overflow en paneles para que los selectores de fecha y otros desplegables puedan visualizarse completos.
* (1111) Análisis de datos -> Edición/creación de balances:
  - Corregido un error por el que no funcionaba la herramienta de selección en mapa.
  - Ahora se visualizarán diferentes símbolos para los contadores externos.
* (1128) Análisis de datos -> Balances:
  - Añadido mapa de balances con polígonos.
* (1133) Principal:
  - Corregida visualización en mapa de los sensores de presión pendientes.
* (1090) Módulo mapa:
  - Sustituida librería Cesium por librerías maplibre.gl y deck.gl.
  - Integrado mapa 3d en el componente del mapa 2d para facilitar su uso.
  - Adaptadas todas las funcionalidades posibles del mapa 2d al 3d.
  - Adaptado mapa 3d a Angular 21.

### Version 5.97.1 (25/03/2026)
* (1098) Dispositivo -> Nuevo:
  - Se permite que los administradores de entidad puedan precargar el contador en el cliente.
  - Cuando se accede desde una pantalla de telemedida, solo podrán añadirse contadores del tipo de dispositivos compatibles con telemedida.

### Version 5.97 (23/03/2026)
* (1077) Alarmas -> Alarmas de agrupación:
  - Añadidos filtros por tipo de dispositivo.
* (1088) Módulo gráficas:
  - Corregida exportación de gráfica de consumo para que ignore la serie de alarmas.
* (1089) Navegación:
  - Actualizados estilos de buscador rápido de entidad/agrupación.
* (1082) Mantenimiento -> Global -> Usuarios (cliente)
 - Añadida columna que indica si los usuarios están activos.
  - Se añade la accion para poder habilitar usuarios desde la tabla.
  - Solo los usuarios Arson podrán eliminar usuarios.
  - Se añade un filtro para ver los usuarios inactivos.
* (1084) Usuarios -> Log -> Global:
  - Nueva pantalla para ver los logs del usuario logeado, accesible desde el menu de usuario .
### Version 5.96.1 (18/03/2026)
* Válvulas:
  - Añadido captcha a acciones de apertura y cierre de válvula.
* Mantenimiento -> Construcción de red:
  - Actualizado tipo de línea de construcción de red.
* Telecontrol -> Panel de alertas activas:
  - Añadido CUPS en tabla y actualizados nombres de columnas de CUPS y número de serie a los configurados en la entidad.
* Telecontrol -> Telemedida:
  - Desaparecen las opciones para las que el usuario_telemedida no tiene acceso.
* Listado de usuarios -> Nuevo/editar:
  - Solucionado error en la preseleccion entidades y clientes al añadir un nuevo usuario del tipo usuario telemedida.
  - Se elimina el check de activado, solo se podrán activar/desactivar usuarios desde el listado.
  - Al añadir o editar un usuario, volveremos a la pantalla anterior.

### Version 5.96 (17/03/2026)
* Dispositivo -> Sustitución -> Informe:
  - Reorganizado el informe de sustitución en un formato de tabla vertical.
  - Añadidas las coordenadas de latitud y longitud al informe de sustitución, mostradas de forma condicional.
* Dispositivo -> Detalle:
  - Ahora no se mostrarán las tarjetas de caudal mínimo y máximo si no se tiene valor.
  - Añadido control para rellenar valores faltantes de datos de consumo horario con nulos y que se muestren en la gráfica sin comprimir el eje.
* Dispositivo -> Logs -> Log de comunicaciones:
  - Corregido error en el que el byte de puerto se incluía al inicio del payload y se cortaba el último byte.
  - Corregido error en el parseador que daba longitud de bytes incorrecta al usar el mismo método de parseo que el log de tramas.
* Usuarios -> Formulario:
  - Añadido combo de cliente para filtrar las entidades seleccionables en los casos de admin y usuario, de entidad y agrupación, para perfil ARSON.
  - Se añade el usuario de telemedida a los usuarios del dropdown para los administradores de entidad.
* Mantenimiento -> Global -> Gateways:
  - Forzado refresco de tabla tras pedir puntos finales para visualizar correctamente la columna.
* Mantenimiento -> Construcción de red:
  - Elementos nuevos: Pozo de sondeo, panel de calidad de agua y fuente de nacimiento.
  - Refactorizado componente para optimizar el rendimiento.
  - Actualizadas conexiones entre piezas con plugin LeaderLine.
* Navegación:
  - Añadido alias a entidad/agrupación en curso.
  - Añadido buscador de entidad/agrupación con panel de cliente.
  - Corregido control de ruta para evitar redirecciones redundantes al cambiar de cliente/entidad/agrupación.
* Rutas:
  - Las rutas en las que se encuentran las páginas fueron refactorizadas para seguir un orden común con el menú lateral y mejorar la navegación.
* Dispositivos:
   - Añadidos dispositivos Rubin Sonic LW8, Rubin Sonic LW y Rubin Sonic W8.
   - Añadidos dispositivos Maddalena Arrow WAN 2 RF Module y Maddalena Arrow WAN 2.
   - Configurados dispositivos Maddalena Arrow WAN 2 para usar el mismo parseo que los Arrow WAN existentes.
* Alarmas -> Alarmas de agrupación:
  - Ahora aparecerán el nombre y los apellidos al elegir usuarios para la creación de mail de aviso.
* Principal -> Agrupación:
  - Independizada gráfica de NBioT UDP de externos.
  - Corregido enlace de gráfica de gateways para perfil usuario ARSON.
* Módulo tabla:
  - Forzada actualización de columnas cuando se altera el orden.
* Módulo mapa:
  - Añadidas capas comunica y no comunica para NBioT UDP.
* Telecontrol -> Telemedida:
  - Corregidas columnas repetidas de CUPS.

### Version 5.95 (05/03/2026)
* Dispositivo -> Detalle -> Actualizar ubicación:
  - Para los cambios de ubicación del gateway, se permite elegir entre reubicación o corrección de coordenadas. En caso de reubicación, se permiten añadir imágenes nuevas para el gateway.
* Datos customizados -> CUPS -> Listado:
  - Añadida opción de exportación completa que incluye todos los datos CUPS de la agrupación, incluyendo columnas ocultas y datos extra.
* Dispositivo -> Nuevo:
  - Añadido fabricante Maddalena con dispositivos Electo SJ y Electo Sonic.
  - Añadidos dispositivos Conthidra Arrow Wan 2 + RF y Conthidra Arrow Wan 2 Split + RF.
* Módulo gráfica:
  - Corregidas interacciones provocadas por la gráfica de Mantenimiento -> Estado de las comunicaciones.
* Usuarios -> Formulario:
  - Corregido un error por el que a veces no se cargaban correctamente los combos de entidad y agrupación.

### Version 5.94.1 (02/03/2026)
* Dispositivo -> Logs
  - Corrección en el parseador del Conthidra E-Register, no salian bien las fechas.
* Mantenimiento -> Monitorización -> Ver datos de entidades:
  - Corregida visualización de columnas.

### Version 5.94 (02/03/2026)
* Dispositivos -> Listado -> Desactivados:
  - Añadida columna de fecha de desactivación de los dispositivos a la tabla de dispositivos desactivados.
* Configuración LNS:
  - Ahora el uplink api key se genera aleatoriamente al crear una nueva configuración, con opción a cambiarlo.
* Dispositivos -> Listado -> No asignados:
  - Añadida opción para pasar a Walk By los dispositivos no asignados activados.
* Dispositivo -> Nuevo:
  - Añadido dispositivo Milesight EM300 DI.
* Dispostivo -> Logs:
  - Añadido parseador para Milesight EM300 DI.
* Contador -> Detalle -> Gráfica de consumo -> Caudales:
 - Añadidos caudales instantáneos a la gráfica.
 - En los caudales se muestran todos los registros por minuto en vez de aparecer uno por hora.
* Tareas:
  - Corregido color de fondo de tareas en el panel de progresión de tareas.
* Principal -> Gestión de cliente:
  - Ahora se harán todas las peticiones de entidades a la vez, en vez de secuenciarlas.
* Análisis de datos -> Balances:
  - Corregido un error por el que al abrir un balance en pestaña nueva no se cargaban correctamente los datos del balance.
* Dispositivo -> Nuevo:
  - Actualizado selector de SIMs con buscador.
  - Corregido servicio de atributos de modelo para concentradores.
* Módulo mapa:
  - Corregida carga y guardado de KML por imagen.
  - Corregido un error que hacía que no se pudiesen cargar los ficheros .kml guardados en servidor.
  - Corregida visualización de cluster para números superiores a 9.999.
* Login:
  - Refactorizado método de login para facilitar su lectura.
* Dispositivo -> Detalle:
  - Desbloqueada visualización día gas para todos los perfiles.
* Mantenimiento -> Monitorización -> Ver datos de entidades:
  - Actualizadas columnas con datos de válvulas, walkby y "con lectura/sin lectura" en vez de "comunica/no comunica" para LW.
* Módulo gráfica:
  - Corrección de unidades para agrupar datos en plantilla por defecto.
* Datos customizados -> CUPS:
  - Corregida importación de CUPS para que si existen columnas sin coincidencias, de el aviso pero prosiga con la importación.
* Navegación:
  - Añadido perfil Usuario Telemedida a opciones de cambio de perfil para ARSON.
* Perfiles:
  - Añadido perfil de usuario Telemedida solo con acceso a lectura en la pantalla de telemedida.

### Versión 5.93 (24/02/2026)
* Telecontrol -> Telemedida:
 - Añadida opción para generar el fichero diario, genera un fichero con los valores diarios a las 6 AM para los dispositivos y rangos de tiempo seleccionados.
* Alarmas -> Alarmas de agrupación:
  - Añadida generación de email para ARSON.
* Mantenimiento -> Global:
  - Corregidas redirecciones con pestaña nueva.
* Mantenimiento -> Global -> Configuración LNS :
  - Añadida pantalla con el resumen de las configuraciones LNS disponibles para el cliente.
* Entidad -> Listado:
  - Se añade una opción en la tabla para poder ver y cambiar la configuración LNS para la entidad.
* Mantenimiento -> Usuarios:
  - Corregido error en el filtrado por perfil por el que en algunos casos filtraban usuarios con perfiles que no coincidian con la búsqueda.
* Dispositivo -> Detalle:
  - Corregido tooltip de concentradores MBus en detalle de contador MBus.
  - Corregidas capas iniciales de mapa en detalle de contador MBus.
  - Eliminado filtro de índice para contadores padre.
  - Corregido un error por el que a veces aparecía el título de la gráfica de fugas.
* Principal -> Gestión de cliente:
  - Corregidas discrepancias de número de alarmas entre gráfica y panel de alarmas destacadas.
  - Añadido filtrado por países si existen entidades en más de un país.
  - Añadido control de click derecho para abrir los enlaces de entidades en pestaña nueva.
  - Actualizado control de visibilidad en tarjeta para poder seleccionar varias entidades a mostrar.
* Módulo gráfica:
  - Corrección de un error que hacía que algunas gráficas mostrasen las columnas de manera errónea por una interacción no deseada de opciones con otras gráficas.
* Análisis de datos -> Balances:
  - Corregido un error por el que no se mostraban las acciones para perfiles de administrador de cliente.
* Selectores:
  - Corregido un error que hacía que al hacer scroll en las opciones de un selector, éstas se generasen a saltos.

### Hotfix 5.92.1 (18/02/2026)
* Navegación:
  - Actualización de página principal al cambiar cliente para ARSON.
* Mantenimiento -> Global -> Gateways:
  - Actualizado orden inicial por estado.
  - Prefiltrados gateways irrecuperables.
  - Actualizados colores de resalte por estado.

### Versión 5.92 (16/02/2026)
* Login:
  - Corregido error por el que al cambiar la contraseña forzosamente desde el inicio de sesión se quedaba en bucle la pagina de cambiar contraseña.
* Alarmas -> Alarmas globales:
  - Corregido parseo de fechas en timezone de agrupación.
* Módulo tabla:
  - Añadida opción de timezone a columna de fechas.
* Navegación:
  - Actualización de control de cambios de cliente/entidad/agrupación a servicio global.
  - Actualizado servicio de chequeo de rutas y guarda de /principal.
* Mantenimiento -> Monitorización -> Crear/editar monitor CCD:
  - Añadido filtro de entidades sin monitor asignado.
  - Actualizados estilos de filtros para que siempre estén visibles al hacer scroll.
* Entidad -> Formulario:
  - Añadido selector de monitor en la creación/edición de entidad.
* Dispositivos -> Listado -> Pendiente:
  - Se añada en la columna de acciones la opción para poder pasar el dispositivo al almacén de cliente.
  - Se añade la opción para poder pasar al almacén del cliente los dispositivos seleccionados.
  - Añadida acción de activación por fichero a menú de tabla para ARSON.
* Principal:
  - Corregido un error por el que si no existían dispositivos pero sí concentradores no aparecía nada en el panel de información de agrupación.
  - Ahora siempre aparecerán los datos de gateways y concentradores si existen, independientemente de que existan dispositivos o no.
* Navegación:
  - Eliminado acceso a listado de entidades desde menú de entidades para administradores de entidad.
* Módulo gráfica:
  - Corrección de actualización de extremos de eje x al cambiar tipo de gráfica.
  - Ahora al actualizar el tipo de serie solo se actualizarán las series correspondientes, no la gráfica al completo.
* Dispositivo -> Gráfica de consumo:
  - Añadida conversión a día gas para gráficas de consumos de contadores de gas, desplazando 6 horas las lecturas para que highcharts agrupe los días de 6:00 a 6:00, actualizando labels y tooltips para compensar la desviación en la visualización.
* Módulo mapa:
  - Anulado bloqueo y reseteo de zoom en mapa de cambio de localización.
  - Actualizados tipos de mapa con variable enum para tener mayor control de errores.
  - Ahora cuando se dibuje la unión de contador y gateway, se añadirán las uniones a gateways redundantes.
  - Corregidos tooltips para contadores LNS Netmore.
* Datos customizados -> CUPS -> Listado:
  - Añadida columna para mostrar la tarifa.
* Datos customizados -> CUPS -> Detalle:
  - Añadida la tarifa en la página principal del CUPS.
* Datos customizados -> CUPS -> Nuevo/Editar:
  - Se permite añadir o editar la tarifa cuando se edita o se añade un CUPS.

### Versión 5.91 (09/02/2026)
* Dispositivo -> Nuevo:
  - Añadido dispositivo Enless TX-PULSE.
  - Añadido dispositivo Kaifa MA603-LoRaWAN.
  - Corregido el error por el que en los inputs de formato numéricos no aparecía para los datos obligatorios.
* Entidades -> Listado :
  - La actualización de la banda y de los canales que antes aparecía en la edición de la entidad, ahora se tendrá que ejecutar por separado desde la tabla de entidades.
* Mantenimiento -> Global -> Instalación/Activación/Desactivación:
  - Añadida búsqueda inicial de 6 horas.
  - El refresco solo pide los datos de los últimos minutos.
  - Implementada pausa automática de refresco al realizar búsqueda manual.
  - No se podrá buscar manualmente ningún periodo de más de 31 días.
* Dispositivos -> Listado pendientes:
  - Actualizados nombres de activos/no activos a instalados/en stock.
* Navegación:
  - Ahora el scroll del menú lateral se hará visible cuando esté disponible.
  - Eliminado link de principal al hacer click sobre el menú de principal en la barra lateral para evitar errores en pantallas táctiles.
  - Actualizado link de logo de entidad para que redirija a la principal de agrupación independientemente del perfil.
* Mantenimiento -> Global -> Carga de batería:
  - Añadida pantalla de carga de batería de gateways con mapa y tabla.
* Principal -> Entidades:
  - Añadida pantalla principal con listado de entidades e información global de dispositivos y alarmas.

### Versión 5.90 (28/01/2026)
* Dispostivo -> Logs:
  - Añadido parseador para Kaifa Gas.
* Dispositivo -> Nuevo:
  - Añadido dispositivo Kaifa Gas.
  - Añadido dispositivo Willfar LXC.
  - Corregido atributo de archivo de importación para Hermes.
* Análisis de datos -> Gráfica de contadores:
  - Añadida comprobación de calibres.
  - Corrección de error de acumulado.
* Gateways -> Listado -> Asignados :
  - Añadida columna de ICCID en la tabla de gateways asignados.
* Dispositivo -> Precarga de datos:
  - Corregida carga de modelos API.
  - Corregida carga de columnas API.
* Navegación:
  - Actualizada pantalla inicial para perfil ARSON.
  - Añadidos logos de financiación europea tras el selector de agrupación para las entidades correspondientes.
* Entidad -> Formulario:
  - Añadido check de financiación para la visualización de logos.
  - Añadida opción para añadir una banda por defecto para los gateways de la entidad
  - Limitadas las opciones de canales por defecto para los gateways de la entidad basandose en la banda seleccionada.
* Módulo mapa:
  - Añadida opción para poder eliminar todas las localizaciones registradas en el mapa (Arson).
* Mantenimiento -> Estado de las comunicaciones:
  - Corregida visualización de estados en gráfica.
* CUPS -> Detalle:
  - Corregido tratamiento de sensores y válvulas.
* Gateway -> Detalle -> Actualizar -> Canales:
  - Añadida la opción para seleccionar la banda del gateway.
  - Limitadas las opciones de canales por defecto para los gateways basándose en la banda seleccionada.
* Módulo tabla:
  - Añadido soporte para filtros de rango en campos de texto (búsqueda entre dos valores).
  - Implementados operadores de comparación de texto (>=, <=, >, <, ==).
  - Actualizado diálogo de filtros especiales para incluir comparaciones de texto.

### Versión 5.89 (20/01/2026)
* Dispostivo -> Logs:
  - Añadido parseador para TFS AMPER HERCULES.
* Dispositivo -> Importaciones -> Importación de datos textuales:
  - Añadida pantalla para poder cargar un archivo con los campos textuales editables para los contadores.
* Módulo mapa:
  - Añadido soporte para sensores de presión.
  - Corrección de color de cluster de externos sin comunicación.
* Dispositivo -> Detalle:
  - Añadido soporte para sensores de presión.
  - Añadida gráfica de presiones cuando es un sensor de presión.
  - Añadida opción de búsqueda en el diálogo de asignar un CUPS al dispositivo.
  - Corregidos varios errores en la geolocalización que evitaban finalizar el proceso si existían errores de cálculo por falta de datos.
  - Aumentado timeout de contador/main para evitar timeout en concentradores mbus.
  - Corregido error por el que los dispositivos Aquaguard no tenian opción para abrir la válvula a la mitad.
* Dispositivo -> Nuevo:
  - Añadido dispositivo TFS AMPER HERCULES.
* Dispositivo -> Gráfica de consumo:
  - Los ínidices vuelven a mostrarse con eje horario.
* Módulo tabla:
  - Corrección de color de fondo de selector de columnas.
* Navegación:
  - Corregida visualización de submenús de barra lateral en resoluciones intermedias.
  - Corregida visualización de barra superior en resoluciones intermedias.
* Módulo gráfica:
  - Corregida visualización de gráfica cuando se invalida la precarga.
* Usuarios -> Formulario:
  - Ocultado selector de perfil en autoedición (el back no permite cambios).
* Datos customizados -> Importar:
  - Añadido botón de descarga de errores en la importación de CUPS.
* Sensórica -> Mapa interactivo de fugas:
  - Corrección de visualización de filtrado de variaciones.
  - Ahora el ancho del slider selector de ruido va ligado directamente al ancho del eje X de la gráfica.

### Versión 5.88 (10/01/2026)
* Dispositivo -> Nuevo:
  - Solucionado error por el que no se veían las API en el seleccionable
* Dispositivos -> Listado -> Asignados:
  - Añadido filtro para LNS NETMORE.
* Dispositivos -> Listado -> No asignados:
  - Añadido filtro para LNS NETMORE.
* Principal:
  - Añadidas tarjetas de contadores LNS NETMORE.
  - Añadidos contadores LNS NETMORE al mapa.
* Mantenimiento -> Monitorización -> Ver datos entidades:
  - Añadida columna de país a cada proyecto.
* Mantenimiento -> Global -> Usuarios-cliente:
  - Añadidas opciones de editar borrar y desactivar usuarios para Arson.
* Dispositivo -> Nuevo:
  - Corrección de datos de modelos API.
  - Añadido Zeus.
* Dispositivo -> Detalle:
  - Actualizados estilos de cabecera.
* Analisis de datos -> Consultas BBDD:
  - Añadida consulta para de contadores instalados entre dos fechas que muestra el listado incluyendo el valor inicial del contador.
`;
